import {
    DTOCardFormField,
} from 'app/types/form.types'
import {
    SizeLink, TypeLink,
} from 'app/shared-components/SkyNetLink'
import {
    LoggerStatus, LoggerMode,
} from 'app/enums/label.enums'
import {
    LoggerResponse,
} from '../Loggers.types'

type LoggerOverviewFields = LoggerResponse & {
    'gateway.locationRemark': string,
    'gateway.location.id': string,
    'gateway.areaName': string,
    'gateway.gatewayImeiMac': string,
}

const loggerFields = ({
    containerSerialNumber,
    getAllowedValues,
    containerLink,
}): DTOCardFormField<keyof LoggerOverviewFields>[] => {
    return [
        {
            id: 'loggers',
            title: 'Loggers',
            className: 'loggers',
            fields: [
                {
                    id: 'loggers-column1',
                    fields: [
                        {
                            name: 'loggerNumber',
                            componentName: 'InputSingleline',
                        },
                        {
                            name: 'loggerQrCode',
                            componentName: 'InputSingleline',
                        },
                        {
                            name: 'containerSerialNumber',
                            componentName: 'SkyNetLink',
                            link: containerLink,
                            title: 'Container Serial Number',
                            text: containerSerialNumber,
                            type: TypeLink.INTERNAL_WITH_ICON,
                            size: SizeLink.S,
                        },
                        {
                            name: 'loggerStatus',
                            componentName: 'EnumSelector',
                            allowedValues: getAllowedValues(LoggerStatus),
                        },
                        {
                            name: 'loggerMode',
                            componentName: 'EnumSelector',
                            allowedValues: getAllowedValues(LoggerMode),
                        },
                        {
                            name: 'loggerType',
                            labelKey: 'LoggerView.loggerType',
                            componentName: 'LoggerTypeSelector',
                        },
                    ],
                },
                {
                    id: 'loggers-column2',
                    fields: [
                        {
                            name: 'isTestingLogger',
                            labelKey: 'Logger.isTestingLogger',
                            componentName: 'Checkbox',
                        },
                        {
                            name: 'hardwareVersion',
                            componentName: 'InputSingleline',
                        },
                        {
                            name: 'softwareVersion',
                            componentName: 'InputSingleline',
                        },
                        {
                            name: 'rentingCompany',
                            componentName: 'CompanyObjectSelector',
                            labelKey: 'Logger.rentingCompany',
                        },
                        {
                            name: 'batteryVoltage',
                            componentName: 'InputSingleline',
                        },
                    ],
                },
                {
                    id: 'loggers-column3',
                    fields: [
                        {
                            name: 'transmissionRateSecondsStatic',
                            componentName: 'IntegerInput',
                        },
                        {
                            name: 'transmissionRateSecondsMobile',
                            componentName: 'IntegerInput',
                        },
                        {
                            name: 'measurementIntervalSeconds',
                            componentName: 'IntegerInput',
                        },
                        {
                            name: 'lastActivatedOn',
                            labelKey: 'Logger.lastActivatedOn',
                            componentName: 'DateTimeSelect',
                            disabled: true,
                        },
                        {
                            name: 'lastCalibratedOn',
                            labelKey: 'Logger.lastCalibratedOn',
                            componentName: 'DateTimeSelect',
                            disabled: true,
                        },
                    ],
                },
            ],
        },
        {
            id: 'gateway',
            title: 'Last Connected Gateway',
            className: 'gateway',
            labelKey: 'Logger.gateway',
            fields: [{
                id: 'gateway-column1',
                fields: [
                    {
                        name: 'gateway.gatewayImeiMac',
                        labelKey: 'Logger.gateway',
                        componentName: 'InputSingleline',
                    },
                    {
                        name: 'gateway.location.id',
                        labelKey: 'Gateway.location',
                        componentName: 'LocationSelector',
                    },
                    {
                        name: 'gateway.areaName',
                        componentName: 'InputSingleline',
                        labelKey: 'Gateway.areaName',
                    },
                    {
                        name: 'gateway.locationRemark',
                        componentName: 'LongText',
                        labelKey: 'Gateway.locationRemark',
                    },
                ],
            }],
        },

    ]
}

export default loggerFields
